import { render, staticRenderFns } from "./PlayerDerbiesTable.vue?vue&type=template&id=4c8a8d4d&scoped=true&"
import script from "./PlayerDerbiesTable.vue?vue&type=script&lang=js&"
export * from "./PlayerDerbiesTable.vue?vue&type=script&lang=js&"
import style0 from "./PlayerDerbiesTable.vue?vue&type=style&index=0&id=4c8a8d4d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c8a8d4d",
  null
  
)

export default component.exports